import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';

import FileCommentItem from './FileCommentItem';
import FileCommentItemReplies from './FileCommentItemReplies';

const propTypes = {
  accountFileComment: PropTypes.shape({
    id: PropTypes.string,
    message: PropTypes.string,
    account: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      avatar_photo: PropTypes.object,
    }),
  }),
  onCommentUpdate: PropTypes.func,
  forceRepliesOpen: PropTypes.bool,
  target: PropTypes.shape({
    fileCommentId: PropTypes.string,
    parentFileCommentId: PropTypes.string,
  }),
};

const RootFileCommentItem = ({
  accountFileComment,
  forceRepliesOpen = false,
  target,
  ...props
}) => {
  const [repliesOpen, setRepliesOpen] = useState(forceRepliesOpen);
  const [focusReplyInput, setFocusReplyInput] = useState(false);

  const replyInputRef = useRef();

  const onReply = () => {
    setRepliesOpen(true);
    setFocusReplyInput(true);
    // In case people hit reply after replies are loaded.
    replyInputRef.current?.focus();
  };

  const onViewReplies = () => {
    setRepliesOpen(true);
  };

  const onRepliesLoaded = () => {
    if (focusReplyInput) {
      replyInputRef.current?.focus();
    }
  };

  return (
    <>
      <FileCommentItem
        repliesOpen={repliesOpen}
        onReply={onReply}
        onViewReplies={onViewReplies}
        accountFileComment={accountFileComment}
        target={target}
        {...props}
      />
      {repliesOpen && (
        <FileCommentItemReplies
          parentAccountFileComment={accountFileComment}
          replyInputRef={replyInputRef}
          onRepliesLoaded={onRepliesLoaded}
          target={target}
        />
      )}
    </>
  );
};

RootFileCommentItem.propTypes = propTypes;

export default RootFileCommentItem;
